export * from './Cache';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/apollo-cache/lib/types/index.js
// module id = 380
// module chunks = 0